export default function Tags({ className, tags }) {
  return (
    <div
      className={className}
      id="lws-singleTags"
    >
      {tags
        ? tags.map((tag) => <span key={Math.random() * 10}>#{tag}</span>)
        : ""}
    </div>
  );
}
